import React from 'react';
import GroupTypeCard from 'components/PageHeader/CreateGroup/GroupTypeCard';
import { GroupType } from 'utils/types';
import { CREATE_STORES, BUNDLE_ITEMS } from 'utils/strings';
import './styles.scss';

interface Props {
  selection: string;
  onSelect: (group: GroupType) => void;
}

const GroupTypeContainer: React.FC<Props> = ({ selection, onSelect }) => (
  <div className="group-type-container">
    <GroupTypeCard
      description={CREATE_STORES}
      selected={selection === 'store'}
      title="Store Group"
      type="store"
      onSelect={() => onSelect('store')}
    />
    <GroupTypeCard
      description={BUNDLE_ITEMS}
      selected={selection === 'item'}
      title="Item Group"
      type="items"
      onSelect={() => onSelect('item')}
    />
  </div>
);

export default GroupTypeContainer;
